import * as CookieConsent from 'vanilla-cookieconsent';

export class CookieConsentClass {
    private readonly cookieConsentExpire = 864000;

    public constructor() {
        this.init();
    }

    private init() {
        window.cc = CookieConsent
        CookieConsent.run({
            categories: {
                analytics: {
                    enabled: true,
                },
            },
            manageScriptTags: true,
            cookie: {
              expiresAfterDays: this.cookieConsentExpire / 60 / 60 / 24,
            },
            language: {
                default: document.documentElement.getAttribute('data-lang'),
                translations: {
                    'fr': {
                        consentModal: {
                            title: 'Nous utilisons des cookies',
                            description: 'Ce site web utilise des cookies essentiels à son bon fonctionnement, ainsi que des cookies de tracking afin de mieux comprendre comment vous intéragissez avec le site web. <button type="button" class="cc-link" onClick="window.cc.showPreferences()">Paramétrer mes cookies</button>',
                            acceptAllBtn: 'Tout accepter',
                            acceptNecessaryBtn: 'Tout rejeter',
                        },
                        preferencesModal: {
                            title: 'Préférence des cookies',
                            savePreferencesBtn: 'Sauver les paramètres',
                            acceptAllBtn: 'Tout accepter',
                            acceptNecessaryBtn: 'Tout refuser',
                            closeIconLabel: 'Fermer',
                            sections: [
                                {
                                    title: 'Les cookies sur Amala',
                                    description: 'Nous utilisons des cookies afin de garantir diverses fonctionnalités essentielles du site et améliorer votre expérience utilisateur. Vous pouvez accepter ou non certains cookies de tracker quand vous le voulez. Pour plus d\'information, consulter notre <a href="/fr/privacy-policy" class="cc-link">politique de confidentialité</a>.'
                                }, {
                                    title: 'Cookies nécessaires et obligatoires',
                                    description: 'Ces cookies sont essentiels au bon fonctionnement du site. Sans ces cookies, le site ne s\'afficherait pas correctement et ne fonctionnerait pas.',
                                    linkedCategory: 'necessary',
                                }, {
                                    title: 'Analyses et statistiques',
                                    description: 'Ces cookies collectent des informations vous concernant et comment vous utilisez le site web (quelles pages avez-vous visité, quels liens avez-vous cliqués, etc.). Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.',
                                    linkedCategory: 'analytics',
                                    cookieTable: {
                                        headers: {
                                            name: "Name",
                                            domain: "Service",
                                            description: "Description",
                                            expiration: "Expiration"
                                        },
                                        body: [
                                            {
                                                name: 'Google Analytics',       // match all cookies starting with "_ga"
                                                domain: 'google.com',
                                                expiration: '2 ans',
                                                description: 'Analysez, traquer et réaliser des rapports de traffic sur le site web.',
                                            },
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        });
    }
}

declare global {
    interface Window {
        cc: any;
    }
}